import { TFunction } from 'i18next'
import { z } from 'zod'

import { CreateAccountFromTemplateFormSchema } from '../types'
import { getAccountFromTemplateFormShape } from './getAccountFromTemplateFormShape'

export const getCreateAccountFromTemplateFormSchema = (t: TFunction): CreateAccountFromTemplateFormSchema =>
  z.object({
    ...getAccountFromTemplateFormShape(t),
    accountNumber: z
      .number({ message: t('coa.account_from_base_form.account_number.error') })
      .nullable()
      .refine((accountNumber) => accountNumber !== null, {
        message: t('coa.account_from_base_form.account_number.error'),
      }),
    baseAccountId: z.string().min(1, t('coa.account_from_base_form.base_account.error')),
  })
